import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogProps,
  DialogTitle,
  SubmitButton,
} from '@fortem-monorepo/react-ui'

import {
  AddSecurityEntryForm,
  AddSecurityEntryFormFields,
} from '@/components/forms/AddSecurityEntryForm'

export interface AddSecurityEntryModalProps extends DialogProps {}

export const AddSecurityEntryModal: React.FC<AddSecurityEntryModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <AddSecurityEntryForm>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader className={'mb-4'}>
                  <DialogTitle>Add Security Entry</DialogTitle>
                  <DialogDescription>
                    Add an entry to both Postrgres and MySQL tables.
                  </DialogDescription>
                </DialogHeader>
                <AddSecurityEntryFormFields />
                <DialogFooter className={'mt-4'}>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton size="sm" loading={isSubmitting} disabled={!isValid}>
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </AddSecurityEntryForm>
      </DialogContent>
    </Dialog>
  )
}
